export default class DocumentIntelligenceProvidersSettings {
    constructor(dto) {
        this.contentTypeID = 0;
        this.documentIntelligenceProviderID = 0;
        this.prebuiltModelID = "";
        this.fieldProviders = [];
        this.lLMModel = "";

        if (dto) {
            this.contentTypeID = dto.ContentTypeID;
            this.documentIntelligenceProviderID = dto.DocumentIntelligenceProviderID;
            this.prebuiltModelID = dto.PrebuiltModelID;
            this.fieldProviders = dto.FieldProviders
            this.lLMModel = dto.LLMModel
        }
    }

    toDto () {
        return {
            ContentTypeID: this.contentTypeID,
            DocumentIntelligenceProviderID: this.documentIntelligenceProviderID,
            PrebuiltModelID: this.prebuiltModelID,
            FieldProviders: this.fieldProviders,
            LLMModel: this.llmModel
        }
    }
}

